<template>
  <div class="plan-card">
    <div
      class="plan-header"
      :style="plan.style">
      <div class="title-with-info-header">
        <div class="title">{{ plan.name }}</div>
        <el-popover
          placement="right"
          width="450"
          trigger="click"
          popper-class="sku-info-popover">
          <div class="sku-detail">
            <div class="sku-title">Plan Information</div>
            <vue-json-pretty
              :data="plan"
              :deep="3"
              :show-length="true"
              :show-line="false">
            </vue-json-pretty>
          </div>
          <svg
            slot="reference"
            class="info-icon"
            width="16"
            height="16"
            viewBox="0 0 16 16"
            fill="none"
            xmlns="http://www.w3.org/2000/svg">
            <circle
              cx="8"
              cy="8"
              r="7"
              stroke="#FF6B6B"
              stroke-width="1.5"/>
            <text
              x="8"
              y="11.5"
              text-anchor="middle"
              fill="#FF6B6B"
              font-size="12"
              font-weight="bold">i</text>
          </svg>
        </el-popover>
      </div>
      <div
        class="plan-price"
        v-if="plan.planPrice">
        <span>{{ plan.planPrice }}</span>
        {{ $t('mediahub.CPU') }}
      </div>
    </div>
    <div class="plan-container">
      <div
        class="cloud-info plan-info scroll-css">
        <template v-for="item in plan.chargeItems">
          <div
            class="info-item"
            v-if="item.permissionCheck !== 1"
            :key="item.id">
            <div class="title-with-info">
              <div class="title">{{ item.addonName }}</div>
              <el-popover
                placement="right"
                width="450"
                trigger="click"
                popper-class="sku-info-popover">
                <div class="sku-detail">
                  <div class="sku-title">SKU Information</div>
                  <vue-json-pretty
                    :data="item"
                    :deep="3"
                    :show-length="true"
                    :show-line="false">
                  </vue-json-pretty>
                </div>
                <svg
                  slot="reference"
                  class="info-icon"
                  width="16"
                  height="16"
                  viewBox="0 0 16 16"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg">
                  <circle
                    cx="8"
                    cy="8"
                    r="7"
                    stroke="#FF6B6B"
                    stroke-width="1.5"/>
                  <text
                    x="8"
                    y="11.5"
                    text-anchor="middle"
                    fill="#FF6B6B"
                    font-size="12"
                    font-weight="bold">i</text>
                </svg>
              </el-popover>
            </div>
            <div class="desc">
              <span class="price">{{ item.tokens }}</span>
              <span v-if="plan.id == 'on_demand'"> tokens per hour.</span>
              <span v-else> tokens per month.</span>
              <!-- on demand是hour  后面的year是month -->
            </div>
          </div>
        </template>
      </div>
      <div
        class="node-info plan-info"
        v-if="plan.classification == 2">
        <div class="info-item">
          Bring Your Own Managed Resource <br> Seamlessly integrate your own resources to host live video routing workflows in TVU MediaHub via a lightweight software agent.
        </div>
        <div
          class="info-item"
          v-if="plan.save">
          <span>{{ $t('mediahub.save') }} </span>
          <span class="price">{{ plan.save }}</span>
          <span> {{ $t('mediahub.perMonth') }}</span>
        </div>
      </div>
    </div>
    <div class="plan-footer">
      <div
        v-if="plan.planType !== 1"
        class="choose"
        :class="{'no-choose':hasExist }"
        @click="handleClickChoose">{{ $t('mediahub.choosePlan') }}</div>
    </div>
  </div>
</template>

<script>
import VueJsonPretty from 'vue-json-pretty'
import 'vue-json-pretty/lib/styles.css'

export default {
  components: {
    VueJsonPretty
  },
  props: {
    plan: Object,
    existPlan: Object || null
  },
  data () {
    return {
      outputNumber: 1,
      lastOutputNumber: 1,
      initOutputNumber: 1
    }
  },
  created () {
    if (this.existPlan) {
      const chargeItems = this.existPlan.chargeItems
      const { Output } = this.handleAddOn(chargeItems)
      // 找到当前的的sub
      this.initOutputNumber = Output.quantity
      this.outputNumber = Output.quantity
      this.lastOutputNumber = Output.quantity
    } else {
      this.initOutputNumber = this.plan.output
      this.outputNumber = this.plan.output
      this.lastOutputNumber = this.plan.output
    }
  },
  methods: {
    handleAddOn (chargeItems) {
      let InputNumber = {}
      let TimeCredit = {}
      let Output = {}
      chargeItems.forEach(i => {
        if (i.addonId == 'producer-input-number') {
          InputNumber = i
        } else if (i.addonId == 'producer-time-credit') {
          TimeCredit = i
        } else if (i.addonId == 'producer-additional-output') {
          Output = i
        }
      })

      return { InputNumber, TimeCredit, Output }
    },
    handleClickChoose () {
      if (this.hasExist) return false
      this.$emit('planchoose', {
        type: 'newPlan',
        id: this.plan.id
      })
    },
    handleChoose () {
      if (this.hasExist || !this.outputNumber) return false
      this.$emit('planchoose', this.plan.id)
    },
    handleInput (value) {
      if (!value) return
      const input = Number(value)
      if (input > 10000) {
        this.outputNumber = this.lastOutputNumber
      } else if (!Number.isInteger(input) || input < this.initOutputNumber) {
        // 判断整数
        this.outputNumber = this.lastOutputNumber
      } else {
        this.lastOutputNumber = input
      }
    }
  },
  computed: {
    hasExist () {
      if (!this.existPlan) return false
      return this.existPlan.planId == this.plan.id
    }
  }
}
</script>

<style lang="less" scoped>
.plan-card {
  width: 380px;
  min-height: 500px;
  text-align: left;
  border-radius: 10px;
  margin: 0 15px;
  box-shadow: 0 10px 20px #0003;
  overflow: hidden;
  background-color: var(--plan-card-bg);
  position: relative;
  .plan-header {
    background: linear-gradient(274.86deg, #BDCFF4 0%, #E6EDFA 100%);
    // height: 134px;
    padding:30px 0 20px;
    .title-with-info-header {
      display: flex;
      align-items: center;
      justify-content: center;
      gap: 8px;
      margin-bottom: 20px;
      .info-icon {
        cursor: pointer;
        flex-shrink: 0;
        transition: transform 0.2s;
        &:hover {
          transform: scale(1.1);
        }
      }
    }
    .title {
      font-weight: 500;
      font-size: 24px;
      text-align: center;
      color: #000000;
      word-break: break-word;
    }
    .price {
      margin: 0;
      font-size: 24px;
      line-height: 24px;
      font-weight: normal;
      .price-num {
        font-weight: 700;
        font-size: 32px;
        line-height: 38px;
      }
    }
    .plan-price {
      color: #252525;
      font-size: 16px;
      text-align: center;
      span {
        font-size: 32px;
        font-weight: 700;
      }
    }
  }

  .plan-container {
    margin: 30px 0;
    .plan-info {
      margin: 20px 0;
      padding: 0 25px;
      height: 300px;
      overflow-y: scroll;
      color: var(--dialog-text-info-color);
      .name {
        width: 50%;
        text-indent: 30px;
      }
      .info-item {
        margin-bottom: 10px;
        word-break: break-word;
        .title-with-info {
          display: flex;
          align-items: center;
          gap: 8px;
          .info-icon {
            cursor: pointer;
            flex-shrink: 0;
            transition: transform 0.2s;
            &:hover {
              transform: scale(1.1);
            }
          }
        }
        .title {
          color: var(--dialog-text-color);
        }
      }
      .price {
        color: #33AB4F;
        font-size: 16px;
        line-height: normal;
      }
      .desc {
        // margin-top: 5px;
      }
      .free-item {
        margin-top: 20px;
      }
    }
    .node-info {
      .info-item {
        span {
          color: #FF9A24;
          font-size: 16px;
        }
        .price {
          font-size: 24px;
        }
      }
    }

    // ::v-deep .el-input {
    //   input[type="number"]::-webkit-inner-spin-button,
    //   input[type="number"]::-webkit-outer-spin-button {
    //     -webkit-appearance: none;
    //     margin: 0; /* Removes the default margin */
    //     background-color: transparent; /* 设置为透明背景色 */
    //   }
    // }
  }

  .plan-footer {
    position: absolute;
    bottom: 20px;
    left: 50%;
    transform: translateX(-50%);
    .choose {
      border: 1px solid #33AB4F;
      color: #33AB4F;
      width: fit-content;
      max-width: 200px;
      height: 16px;
      line-height: 16px;
      padding: 10px 8px;
      text-align: center;
      border-radius: 5px;
      margin: 0 auto;
      cursor: pointer;
      transition: all .3s;
      user-select: none;
    }
    // .choose:hover {
    //   background: #33AB4F;
    //   color: #fff;
    // }
    .no-choose {
      cursor: no-drop;
      background: #33AB4F;
      color: #fff;
    }
    .no-drop {
      cursor: no-drop;
    }
    // .no-choose:hover {
    //   color: #33AB4F;
    //   background: none;
    // }
  }
}
</style>

<style lang="less">
.sku-info-popover {
  background: #1e1e1e !important;
  border: 1px solid #444444 !important;
  color: #dbdbdb !important;

  .popper__arrow::after {
    border-right-color: #1e1e1e !important;
  }

  .sku-detail {
    max-height: 500px;
    overflow-y: auto;

    .sku-title {
      font-size: 16px;
      font-weight: 700;
      color: #ffffff;
      margin-bottom: 12px;
      border-bottom: 1px solid #444444;
      padding-bottom: 8px;
    }

    .vjs-tree {
      font-size: 13px;

      .vjs-key {
        color: #9cdcfe !important;
      }

      .vjs-value__string {
        color: #ce9178 !important;
      }

      .vjs-value__number {
        color: #b5cea8 !important;
      }

      .vjs-value__boolean {
        color: #569cd6 !important;
      }

      .vjs-value__null {
        color: #808080 !important;
      }

      .vjs-tree-brackets {
        color: #ffd700 !important;
      }
    }
  }
}
.vjs-tree {
  word-break: normal;
}
</style>
